module.exports = __webpack_public_path__ + "img/KSC02243.320912f3.jpg";